import { render, staticRenderFns } from "./UcInvoiceHeader.yaml?vue&type=template&id=6906ef4e&component"
import script from "./UcInvoiceHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports